import React, { useState } from "react";
import { defineMessages, useIntl } from "react-intl";

import StillImage from "@/components/still-image";
import { useModalContext } from "@/contexts/modal-context";
import { type Account, type Attachment } from "@/schemas";
import { headerMissing } from "@/schemas/account";
import { isDefaultHeader } from "@/utils/accounts";

const messages = defineMessages({
  header: { id: "account.header.alt", defaultMessage: "Profile header" },
});

interface HeaderImageProps {
  account: Account;
  withLink?: boolean;
}

export default function HeaderImage(props: HeaderImageProps) {
  const { account, withLink = true } = props;

  const intl = useIntl();
  const { openModal } = useModalContext();

  const [isError, setIsError] = useState(false);

  const imageSrc = isError ? headerMissing : account.header_static;

  function handleError() {
    setIsError(true);
  }

  function handleHeaderClick(event: React.MouseEvent<HTMLAnchorElement>) {
    if (event.button === 0 && !(event.ctrlKey || event.metaKey)) {
      event.preventDefault();

      const header = {
        type: "image",
        url: imageSrc,
      } as Attachment;

      openModal("MEDIA", { media: [{ attachment: header }] });
    }
  }

  const image = (
    <StillImage
      src={imageSrc}
      alt={intl.formatMessage(messages.header)}
      onError={handleError}
    />
  );

  if (isDefaultHeader(imageSrc)) {
    return image;
  }

  if (!withLink) {
    return image;
  }

  return (
    <a
      href={account.header_static}
      onClick={handleHeaderClick}
      target="_blank"
      rel="noopener noreferrer"
    >
      {image}
    </a>
  );
}
